export const environment = {
  production: false,
  appUrl: 'https://farmsim.dev.nachocast.com',
  // DEV deployment (frontend is hosted on GoDaddy, backend is on EC2).
  // NOTE: This must be HTTPS to avoid mixed-content. Since the EC2 host currently
  // has no HTTPS listener, API calls from https://www.farmsim.dev.nachocast.com
  // will be blocked by the browser until HTTPS is enabled on the backend.
  apiUrl: 'https://api.ssanamisound.com/api',
  authConfig: {
    region: 'us-east-2',
    userPoolId: 'us-east-2_XdCZ8Nkks',
    userPoolWebClientId: '4bpfsvhjiulkm0o7646h4qua1k',
    // Corrected domain format - using the proper Cognito domain format
    domain: 'farmsim-auth-dev.auth.us-east-2.amazoncognito.com'
  },
  ads: {
    enabled: false,
    clientId: 'ca-pub-XXXXXXXXXXXX',
    farmListSlot: '1234567890',
    plantingListSlot: '2234567890',
    todoDashboardSlot: '3234567890',
  },
};
